/* Post-Flutterwave redirect landing for doorbell wallet top-ups. Polls
   the verify endpoint until the txn either completes or errors. */
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DoorbellTopupComplete() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const txRef = params.get("tx_ref");
  const transactionId = params.get("transaction_id") || params.get("transaction_id");
  const [status, setStatus] = useState("pending");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!txRef) { setStatus("missing"); return; }
    let cancelled = false;
    const tick = async () => {
      try {
        const url = `${API}/doorbell/wallet/topup/verify/${txRef}${transactionId ? `?transaction_id=${transactionId}` : ""}`;
        const r = await axios.get(url, { withCredentials: true });
        if (cancelled) return;
        setStatus(r.data.status);
        setAmount(r.data.amount_ngn);
      } catch { /* keep polling */ }
    };
    tick();
    const id = setInterval(() => {
      if (status === "completed" || status === "underpaid") { clearInterval(id); return; }
      tick();
    }, 3000);
    return () => { cancelled = true; clearInterval(id); };
  }, [txRef, transactionId, status]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="topup-complete-page">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-sm p-6 text-center">
        {status === "completed" ? (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3" />
            <p className="font-heading text-2xl font-black tracking-tighter mb-1" data-testid="topup-completed">Wallet topped up</p>
            <p className="text-sm text-gray-600 font-body mb-4">₦{(amount || 0).toLocaleString()} added. Your doorbell is now active.</p>
          </>
        ) : status === "underpaid" ? (
          <>
            <AlertTriangle className="w-12 h-12 text-yellow-500 mx-auto mb-3" />
            <p className="font-heading text-2xl font-black tracking-tighter mb-1">Top-up failed</p>
            <p className="text-sm text-gray-600 font-body mb-4">If funds were debited, contact support.</p>
          </>
        ) : status === "missing" ? (
          <p className="text-sm text-gray-600 font-body">Missing transaction reference.</p>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-gray-400 mx-auto mb-3 animate-spin" />
            <p className="font-heading text-2xl font-black tracking-tighter mb-1">Confirming payment...</p>
            <p className="text-sm text-gray-600 font-body mb-4">This usually takes a few seconds.</p>
          </>
        )}
        <Button onClick={() => navigate("/dashboard")} className="bg-black hover:bg-gray-800 text-white rounded-sm font-body" data-testid="topup-back-dashboard">
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}
